import { useNavigate } from 'react-router-dom';

const BookPopUp = ({ book, showPopup, setShowPopup }) => {
    const navigate = useNavigate(); 
    const handleClicknew = (e) => {
        e.preventDefault();
        if (book?.book_link && book?.book_id) {
            setShowPopup(false);
            const fileLink = book.book_link; 
            const bookId = book.book_id;
            const fileExtension = fileLink.split('.').pop().toLowerCase(); 
            if (fileExtension === "pdf") {
                navigate('/pdf', { state: { message: fileLink, id: bookId } }); 
            } else if (fileExtension === "epub") {
                navigate('/epub', { state: { message: fileLink, id: bookId } }); 
            } else {
                alert("Unsupported file format. Only PDF and EPUB are supported.");
            }
        }
    };
    
    
    
    return (
        <>
            {showPopup && book && (
                <div className="modal book_of_the_day" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-dialog-centered cover_image">
                        <div className="modal-content" data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                            <button className="modal-close icofont-close" onClick={() => setShowPopup(false)}></button>
                            <div className="product-view">
                                <button type='button' onClick={handleClicknew} >
                                    <img className='w-100' src={`${process.env.PUBLIC_URL}/assets/images/elements/book_of_the_day.png`} alt="logo" />
                                    <div className="col-md-12 col-lg-12">
                                        <div className="row view-gallery">
                                            <div className='col-5'>
                                                <img src={book.image} alt={book.book_name} />
                                            </div>
                                            <div className='col-5 book_titles'>
                                                <h3 className="view-name">{book.book_name}</h3>
                                                <h5>{book.book_author}</h5>
                                                <h5>{book.book_genre}</h5>
                                                <h5>{book.book_lang}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default BookPopUp;
